import React, { ReactNode } from 'react';

export interface TableWrapperProps {
  title?: ReactNode;
  subTitle?: ReactNode;
  filters?: ReactNode;
  children?: ReactNode;
}

export default function TableWrapper({
  title,
  subTitle,
  filters,
  children,
}: TableWrapperProps) {
  return (
    <div className="bg-white rounded-xl">
      <header className="flex items-center justify-between p-6">
        <div className="space-y-1">
          <h2 className="text-2xl font-semibold text-gray-900">{title}</h2>
          <p className="text-sm text-gray-500">{subTitle}</p>
        </div>

        {!!filters && <div className="">{filters}</div>}
      </header>

      <section>{children}</section>
    </div>
  );
}
